"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.export_table_to_excel = export_table_to_excel;
var _fileSaver = _interopRequireDefault(require("file-saver"));
var _xlsx = _interopRequireDefault(require("xlsx"));
/* eslint-disable */

/**
 * 导出excel
 * @param id
 * @param filenanme
 * @returns {void | Promise<any> | *}
 */
function export_table_to_excel(id, filenanme) {
  var wb = _xlsx.default.utils.table_to_book(document.querySelector(id));
  var wbout = _xlsx.default.write(wb, {
    bookType: 'xlsx',
    bookSST: true,
    type: 'array'
  });
  try {
    _fileSaver.default.saveAs(new Blob([wbout], {
      type: 'application/octet-stream'
    }), filenanme + '.xlsx');
  } catch (e) {
    if (typeof console !== 'undefined') console.log(e, wbout);
  }
  return wbout;
}